import React from "react";
import { ListGroup } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { titleCase } from "../../utils/index";
import "./../products/show.css";

const ProductCardItem = ({ product }) => {
  const firstImage =
    product.images && product.images.length > 0 ? product.images[0] : null;

  return (
    <div
      style={{
        marginBottom: "15px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#fff",
        overflow: "hidden",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "1em",
          backgroundColor: "#f7f7f7",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {firstImage && (
          <LazyLoadImage
            src={firstImage}
            alt={product.name}
            style={{
              height: "100px",
              width: "100px",
              objectFit: "contain",
              marginRight: "15px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              background: "#fff",
              padding: "4px",
            }}
          />
        )}
        <h6
          style={{
            margin: 0,
            fontSize: "16px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          {titleCase(product.name)}
        </h6>
      </div>

      {/* Body */}
      <div style={{ padding: "20px" }}>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <span style={{ fontWeight: "bold" }}>Description: </span> <br />
            <div
              style={{
                marginTop: "10px",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              dangerouslySetInnerHTML={{
                __html: product.description ? product.description : "",
              }}
            />
            {product.description && product.description.length > 100 && (
              <Link
                to={`/admin/products/${product.id}`}
                style={{
                  display: "inline-block",
                  marginTop: "6px",
                  color: "#007bff",
                  fontSize: "14px",
                }}
              >
                Read More
              </Link>
            )}
          </ListGroup.Item>

          <ListGroup.Item>
            <span style={{ fontWeight: "bold" }}>Colors: </span>
            <div style={{ display: "flex", flexDirection: "row", marginTop: "8px", flexWrap: "wrap", gap: "12px" }}>
              {product.readable_colors &&
                product.readable_colors.map((color, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      margin: "0 6px",
                    }}
                  >
                    <div
                      style={{
                        height: "30px",
                        width: "30px",
                        backgroundColor: color.value,
                        border: "2px solid #ccc",
                        borderRadius: "4px",
                        marginBottom: "4px",
                      }}
                    ></div>
                    <span style={{ fontSize: "12px", color: "#333" }}>
                      {color.label}
                    </span>
                  </div>
                ))}
            </div>
          </ListGroup.Item>

          <ListGroup.Item>
            <span style={{ fontWeight: "bold" }}>Sizes: </span>{" "}
            {product.readable_sizes &&
              product.readable_sizes.map((size, i) => (
                <span key={i}>{size.label}, </span>
              ))}
          </ListGroup.Item>
        </ListGroup>
      </div>
    </div>
  );
};

export default ProductCardItem;
